export default "__VITE_ASSET__KFH28MAr__"